<div class="td-settings-panel grid-settings-panel w-full h-full;">
  <div class="h-full" style="display: grid; grid-template-rows: 1fr auto; height: 100% !important;">
    <div
      class="w-full"
      style="overflow: auto; display: grid; grid-template-rows: auto 1fr"
    >
      <div class="search-container">
        <div class="search-header">
          <input
            type="text"
            placeholder="Search columns..."
            [(ngModel)]="searchTerm"
            (ngModelChange)="onSearchChange()"
            class="search-input"
          />
          <button
            (click)="refreshColumnState()"
            class="refresh-btn"
            title="Refresh columns"
            type="button"
          >
            🔄
          </button>
        </div>
      </div>
      <div class="column-list">
        <div
          *ngFor="let col of filteredColumns; let i = index"
          class="column-item"
          [id]="1"
          [attr.data-col-id]="col.id"
          #columnItem
        >
          <label class="column-label">
            <input
              type="checkbox"
              [checked]="col.visible"
              (change)="onToggleColumnVisibility(col,i)"
              class="column-checkbox"
            />
            <span class="column-name">{{ col.name }}</span>
          </label>
          <div class="column-actions">
            <label class="pin-switch" [title]="col.pinned  ? 'Unpin column' : 'Pin column to left'">
              <input
                type="checkbox"
                [checked]="col.pinned"
                (change)="onToggleColumnPin(col,i)"
                class="pin-checkbox"
              />
              <span class="pin-label" [class.pinned]="col.pinned">
                {{ col.pinned ? '📌' : '📍' }}
              </span>
            </label>
          </div>
        </div>
        <div *ngIf="filteredColumns.length === 0" class="no-columns">
          <p>No columns found.</p>
        </div>
      </div>
    </div>

    <div class="w-full">
      <div class="form-group">
        <div class="button-container">
          <button
            (click)="onSaveClick()"
            class="btn btn-success btn-save"
            type="button"
            [disabled]="isSaveLoading || isResetLoading"
          >
            <i>{{ isSaveLoading ? '⏳' : '💾' }}</i>
            {{ isSaveLoading ? 'Saving...' : 'Save Settings' }}
          </button>
          <button
            (click)="onResetClick()"
            class="btn btn-danger btn-reset"
            type="button"
            [disabled]="isSaveLoading || isResetLoading"
          >
            <i>{{ isResetLoading ? '⏳' : '🔄' }}</i>
            {{ isResetLoading ? 'Resetting...' : 'Reset Settings' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
